import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const impairment = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumber',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumber'
            },
            filteredValue: filteredInfo.contractNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同名称',
            dataIndex: 'contractName',
            key: 'contractName',
            scopedSlots: {
                customRender: 'contractName',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '执行合同编号',
            dataIndex: 'executeContractNumber',
            key: 'executeContractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'executeContractNumber'
            },
            filteredValue: filteredInfo.executeContractNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同金额',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同类型',
            dataIndex: 'projectType',
            key: 'projectType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.projectType || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同分类',
            dataIndex: 'contractType',
            key: 'contractType',
            scopedSlots: {
                filterDropdown: 'filterContractType',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractType'
            },
            filteredValue: filteredInfo.contractType || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同拟定时间',
            dataIndex: 'contractDraftingDate',
            key: 'contractDraftingDate',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '销售',
            dataIndex: 'sales.name',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '增值金额',
            dataIndex: 'addedAmount',
            key: 'addedAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'addedAmount'
            },
            filteredValue: filteredInfo.addedAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '可开票金额',
            dataIndex: 'invoicedAmount',
            key: 'invoicedAmount',
            scopedSlots: {
                customRender: 'invoicedAmount'
            }
        },
        {
            title: '已开票金额',
            dataIndex: 'invoicingAmount',
            key: 'invoicingAmount',
            scopedSlots: {
                customRender: 'invoicingAmount'
            }
        },
        {
            title: '是否已转预付款',
            dataIndex: 'impairmentFlag',
            key: 'impairmentFlag',
            scopedSlots: {
                filterDropdown: 'filterFlag',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'impairmentFlag'
            },
            filteredValue: filteredInfo.impairmentFlag || [],
        },
        {
            title: '签订地点',
            dataIndex: 'signingPlace',
            key: 'signingPlace',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'signingPlace'
            },
            filteredValue: filteredInfo.signingPlace || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '客户单位',
            dataIndex: 'customerContacts.companyName',
            key: 'customerCompanyName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.customerCompanyName || [],
        },
        {
            title: '委托方（甲方）',
            dataIndex: 'customerContacts.contactName',
            key: 'customerContactsName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contact'
            },
            filteredValue: filteredInfo.customerContactsName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '受托方（乙方）',
            dataIndex: 'baseCompany.companyName',
            key: 'baseCompanyName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.baseCompanyName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '乙方项目联系人',
            dataIndex: 'trusteeContacts.name',
            key: 'trusteeContactsName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.trusteeContactsName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
